import { GET, POST, PUT, DELETE } from '../utils/crud'

const list = async () => {
  const res = await GET('specialities')
  return res
}

const create = async (body) => {
  const data = { name: body }
  const res = await POST('specialities', data)
  return res
}

const edit = async (body) => {
  const { id, update } = body
  const data = { name: update }
  const res = await PUT(`specialities/${id}`, data)
  return res
}

const destroy = async (id) => {
  const res = await DELETE(`specialities/${id}`)
  return res
}
const show = async (id) => {
  const res = await GET(`specialities/${id}`)
  return res
}
export default {
  list,
  create,
  edit,
  destroy,
  show,
}
